import { request } from '../utils/request'
import type {
  CategoryExhibitionResponse,
  ContinueReadingPageResponse,
  HomeCategoryOption,
} from '../types/home'

/**
 * 获取首页延续阅读分页数据。
 */
export const getContinueReadingPage = async (pageNum: number) => {
  const response = await request.get('/api/v2/home/continue-reading', {
    params: { page_num: pageNum },
    headers: { 'X-Skip-401-Redirect': '1', 'X-Silent': '1' },
  })
  return (response.data?.data || {}) as ContinueReadingPageResponse
}

/**
 * 上报延续阅读点击事件。
 */
export const trackContinueReadingClick = async (payload: { book_id: number; position: number }) => {
  const response = await request.post('/api/v2/home/continue-reading/click', payload, {
    headers: { 'X-Skip-401-Redirect': '1', 'X-Silent': '1', 'X-No-Retry': '1' },
  })
  return response.data?.data || null
}

/**
 * 获取首页分类展览数据。
 */
export const getCategoryExhibition = async (payload: { category: string; pageNum?: number; pageSize?: number }) => {
  const response = await request.get('/api/v2/home/category-exhibition', {
    params: {
      category: payload.category,
      page_num: payload.pageNum || 1,
      page_size: payload.pageSize || 12,
    },
    headers: { 'X-Skip-401-Redirect': '1', 'X-Silent': '1', 'X-No-Retry': '1' },
  })
  return (response.data?.data || {}) as CategoryExhibitionResponse
}

/**
 * 获取首页分类展览一级分类。
 */
export const getCategoryExhibitionCategories = async (query = '') => {
  const response = await request.get('/api/v2/home/category-exhibition/categories', {
    params: {
      q: query,
    },
    headers: { 'X-Skip-401-Redirect': '1', 'X-Silent': '1', 'X-No-Retry': '1' },
  })
  return (Array.isArray(response.data?.data) ? response.data.data : []) as HomeCategoryOption[]
}
